import { SearchOutlined } from "@ant-design/icons";
import { PhaseNode } from "../model/types/ProjectTree";
import { SelectedItem } from "../model/types/ProjectSelection";
import {
  BaseSelect,
  SelectOption,
} from "components/AntDesign/Select/BaseSelect";

type PhaseSelectorProps = {
  phases: PhaseNode[];
  value: SelectedItem[];
  disabled?: boolean;
  onChange: (value: SelectedItem[]) => void;
};

export function PhaseSelector({
  phases,
  value,
  disabled,
  onChange,
}: PhaseSelectorProps) {
  const options: SelectOption<number>[] = phases.map((ph) => ({
    value: ph.id,
    label: ph.label,
  }));

  const selectedValue = value[0]?.id;

  const handleChange = (val?: number) => {
    if (val === undefined) {
      onChange([]);
      return;
    }

    const option = options.find((o) => o.value === val);

    onChange([
      {
        id: val,
        label: option?.label ?? "",
      },
    ]);
  };

  return (
    <BaseSelect<number>
      options={options}
      value={selectedValue}
      disabled={disabled}
      prefix={<SearchOutlined />}
      float={{ label: "Select phase" }}
      onChange={handleChange}
    />
  );
}
